import { Box, Grid } from "@mui/material";
import ClientCard from "components/ui/ClientFlow/ClientCard";
import React, { useEffect } from "react";
import { useOrderSummary } from "./API/getAllStatusWiseOrders";
import { useParams } from "react-router-dom";
import LoadingSmallCard from "components/ui/Skeleton/LoadingSmallCard";
import TransactionSmallCard from "components/ui/Skeleton/TransactionSmallCard";
import { useClientContext } from "context/ClientContext";

export function formatOrderSummary(data) {
  const gradientMap = {
    ALL: "linear-gradient(180deg, #5B88E2 0%, #324A7C 97.9%)",
    Pending: "linear-gradient(180deg, #E6DA5D 0%, #7C7532 97.9%)",
    WIP: "linear-gradient(180deg, #E2935B 0%, #7C5132 97.9%)",
    Completed: "linear-gradient(180deg, #5BE272 0%, #327C3E 97.9%)",
    Cancelled: "linear-gradient(180deg, #E25B5B 0%, #7C3232 97.9%)",
  };

  return (
    data
      // .filter((item) => item.count !== 0) // remove zero-count items
      .map((item) => ({
        name: item?.label === "ALL" ? "All orders" : `${item?.label} orders`,
        count: item?.count || 0,
        bg: gradientMap[item?.label],
        details: [
          {
            icon: "RedBag",
            count: item?.bagCount,
          },
          {
            icon: "Small_Diamond",
            count: `${item?.diaWeight.toFixed(2)}Ct`,
          },
          {
            icon: "GoldBar",
            count: `${item?.netWeight.toFixed(2)}g`,
          },
        ],
      }))
  );
}

function OrderPage() {
  const { clientId } = useParams();
  const { data, isLoading, isError, isFetching } = useOrderSummary(clientId);
  const orderData = data ? formatOrderSummary(data) : [];

  if (isLoading) {
    return <TransactionSmallCard count={5} />;
  }

  if (isError) {
    return <p>Error Found </p>;
  }

  return (
    <>
      {orderData?.length && (
        <Grid container sx={{ display: "flex", gap: "2rem" }}>
          {orderData.length &&
            orderData.map((data) => {
              return (
                <Grid item sx={{ padding: "0px !important" }}>
                  <ClientCard data={data} showLine={true} page="purchase" />
                </Grid>
              );
            })}
        </Grid>
      )}
    </>
  );
}

export default OrderPage;
